/**
 * useSkus
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import SkusContext from './skus-context'

const useSkus = () => {
  const context = useContext(SkusContext)
  return context
}

export default useSkus
